'use strict';
import AXIOS from 'axios';

const ProcessRequest = (options) =>{
  return AXIOS(options);
}

export default ProcessRequest;
